import { idealPattern, fromRunwayFrame, runwayByIdent, KCCR, DEFAULT_SCORING, FT_M, KT_MS, destination } from '@fst/analysis';
import type { TrackPoint } from '../api/types';

export const KCCR_CENTER: [number, number] = [KCCR.lon, KCCR.lat];
export const FIELD_ELEV_M = KCCR.elevationFt * FT_M;
export const hafToMslM = (hAF: number) => (hAF + KCCR.elevationFt) * FT_M;

/** Ideal pattern as [lon, lat, altMslM] triples. */
export function idealPath(runway: string, direction: 'left' | 'right', o: { tpaFt: number; downwindNm: number; turnRadiusNm: number }): [number, number, number][] {
  const rw = runwayByIdent(KCCR, runway);
  const ip = idealPattern(rw, { ...DEFAULT_SCORING, ...o }, direction);
  return ip.points.map(p => { const { lat, lon } = fromRunwayFrame(rw, p.along, p.cross); return [lon, lat, hafToMslM(p.hAF)] as [number, number, number]; });
}

export function deadReckon(p: { lat: number; lon: number; gs: number; track: number }, ageS: number): { lat: number; lon: number } {
  const dt = Math.min(30, Math.max(0, ageS));
  return destination(p.lat, p.lon, p.track, p.gs * KT_MS * dt);
}

export const PHASE_COLORS: Record<string, [number, number, number]> = {
  taxi: [120, 120, 130], parked: [90, 90, 100], takeoff_roll: [245, 179, 1], initial_climb: [245, 179, 1], climb: [250, 204, 21], cruise: [156, 163, 175], maneuvering: [167, 139, 250], descent: [96, 165, 250],
  upwind: [245, 179, 1], turn_crosswind: [245, 179, 1], crosswind: [34, 211, 238], turn_downwind: [34, 211, 238], downwind: [163, 230, 53], turn_base: [163, 230, 53], base: [251, 113, 133], turn_final: [251, 113, 133], final: [255, 255, 255], landing_roll: [120, 120, 130],
};
export const phaseColor = (phase: string | null): [number, number, number] => PHASE_COLORS[phase ?? ''] ?? [156, 163, 175];

export interface Segment { phase: string | null; path: [number, number, number][]; ts: number[]; interpolated: boolean; circuitSeq: number | null }
/** Consecutive same-phase runs; each segment repeats the next segment's first point so the line is continuous. */
export function splitByPhase(pts: TrackPoint[]): Segment[] {
  const out: Segment[] = [];
  for (let i = 0; i < pts.length; i++) {
    const p = pts[i]!, key = p.phase ?? null, interp = !!p.interpolated;
    const last = out[out.length - 1];
    const pos: [number, number, number] = [p.lon, p.lat, hafToMslM(p.hAF)];
    if (last && last.phase === key && last.interpolated === interp && last.circuitSeq === p.circuitSeq) { last.path.push(pos); last.ts.push(p.ts); }
    else { if (last) { last.path.push(pos); last.ts.push(p.ts); } out.push({ phase: key, path: [pos], ts: [p.ts], interpolated: interp, circuitSeq: p.circuitSeq }); }
  }
  return out;
}
